<template>
	<div class="jobs-wrapper">
		<h3 v-if="heading" class="heading heading--md">Job Listing</h3>

		<JobsFilter
			:locations="locations"
			:departments="departments"
			:projects="projects"
			:filters="filters"
			:positionsLength="positionsCount"
			:theme="theme"
			@change="onFiltersChange"
		/>

		<JobsTable :list="positions" :theme="theme" />

		<div
			v-if="paginated && activePage < pages"
			class="jobs__load-more text-center"
		>
			<BasicButton tag="button" type="black-bordered" @click="loadMore"
				>View More</BasicButton
			>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import JobsFilter from "./JobsFilter";
import JobsTable from "./JobsTable";
import BasicButton from "../BasicButton";

import { sanitizeFilter } from "../../utils/filters";
import { getPositions } from "../../services/positions";

export default {
	name: "jobs",
	components: {
		JobsFilter,
		JobsTable,
		BasicButton
	},
	mounted() {
		// From testing, without a brief timeout, it won't work.
		if (this.$route.hash) {
			setTimeout(() => this.scrollTo(this.$route.hash), 100);
		}
	},
	props: {
		defaultFilters: Object,
		paginated: Boolean,
		heading: Boolean,
		theme: {
			type: String,
			default: "primary",
			validator(value) {
				return ["primary", "blue"].indexOf(value) >= 0;
			}
		}
	},
	data() {
		return {
			filters: null,
			positions: null,
			positionsCount: 0,
			loading: false,
			failed: false,
			activePage: 1,
			pages: 0
		};
	},
	computed: {
		...mapState({
			departments: state => state.jobs.departments,
			locations: state => state.jobs.locations,
			projects: state => state.jobs.projects
		}),
		params() {
			if (
				this.$route.query.projects &&
				!Array.isArray(this.$route.query.projects)
			) {
				this.$route.query.projects = [this.$route.query.projects];
			}
			if (
				this.$route.query.locations &&
				!Array.isArray(this.$route.query.locations)
			) {
				this.$route.query.locations = [this.$route.query.locations];
			}
			if (
				this.$route.query.departments &&
				!Array.isArray(this.$route.query.departments)
			) {
				this.$route.query.departments = [this.$route.query.departments];
			}
			return this.$route.query;
		},
		positionsLength() {
			return this.positions ? this.positions.length : 0;
		}
	},
	methods: {
		...mapActions("jobs", ["getFilters"]),
		scrollTo: function(hashtag) {
			setTimeout(() => {
				location.href = hashtag;
			}, 100);
		},
		onFiltersChange(filters) {
			if (!filters.q.length) {
				delete filters.q;
			}
			this.activePage = 1;
			this.updateUrl(filters);
			this.getJobs(filters);
		},
		updateUrl(query) {
			this.$router.push({ query });
		},
		setFilters(filters) {
			const newFilters = JSON.parse(JSON.stringify(filters));
			const setFromArray = (node, list) => {
				return sanitizeFilter(node).map(id =>
					list.find(item => item.id === id)
				);
			};

			if (newFilters["locations"]) {
				newFilters.locations = setFromArray(
					newFilters["locations"],
					this.locations
				);
			}
			if (newFilters["departments"]) {
				newFilters.departments = setFromArray(
					newFilters["departments"],
					this.departments
				);
			}
			if (newFilters["projects"]) {
				newFilters.projects = setFromArray(
					newFilters["projects"],
					this.projects
				);
			}

			this.filters = newFilters;
		},
		async getJobs(filters) {
			try {
				this.loading = true;
				const { rows, pages, count } = await getPositions({
					page: this.activePage,
					...filters
				});

				if (this.activePage === 1) {
					this.positions = rows;
				} else {
					this.positions.push(...rows);
				}
				this.pages = pages;
				this.positionsCount = count;

				this.loading = false;
				this.failed = false;
			} catch (e) {
				console.log("error on fetching", e);
				this.loading = false;
				this.failed = true;
			}
		},
		async loadData() {
			await this.getFilters();
			if (
				Object.keys(this.params).length ||
				(this.defaultFilters && Object.keys(this.defaultFilters).length)
			) {
				const filters = Object.assign(
					{},
					this.params,
					this.defaultFilters
				);
				this.setFilters(filters);
			}
			this.getJobs(this.params);
		},
		loadMore() {
			this.activePage = this.activePage + 1;
			this.getJobs(this.params);
		}
	},
	async created() {
		this.loadData();
	}
};
</script>

<style lang="scss" scoped type="text/scss">
@import "../../assets/scss/globals";

.jobs-wrapper {
	padding-top: 28px;

	.heading {
		margin-bottom: 70px;
	}

	@media (max-width: $mq-sm-max) {
		padding-top: 30px;

		.heading {
			margin-bottom: 40px;
		}
	}
}

.jobs__load-more {
	margin-top: 110px;

	@media (max-width: $mq-sm-max) {
		margin-top: 60px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/Jobs.vue